import React from "react";
import { Space, Typography } from "antd";
import { TAG_SEVERITY_COLORS, TAG_CATEGORY_LABELS, TagCategory } from "../../../types/healthcare/BodyAnalysisTypes";

const { Text } = Typography;

const SEVERITIES = [
	{ key: "critical" as const, label: "Critical" },
	{ key: "warning"  as const, label: "Warning" },
];

const CATEGORIES = Object.keys(TAG_CATEGORY_LABELS) as TagCategory[];

interface BodyModelLegendProps {
	showCategories?: boolean;
}

const BodyModelLegend: React.FC<BodyModelLegendProps> = ({ showCategories = false }) => (
	<div style={{ fontSize: 11 }}>
		<Space wrap size={8}>
			{SEVERITIES.map(({ key, label }) => (
				<Space key={key} size={4} align="center">
					<span
						style={{
							display: "inline-block",
							width: 10,
							height: 10,
							borderRadius: "50%",
							background: TAG_SEVERITY_COLORS[key],
						}}
					/>
					<Text type="secondary" style={{ fontSize: 11 }}>{label}</Text>
				</Space>
			))}
		</Space>
	</div>
);

export default BodyModelLegend;
